import type { ThemeV3 } from '../types/themeTypes';

export const satsumaTheme = {
  id: 'Satsuma',
  name: 'Satsuma',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': 'oklch(90.87% 0.0173 79.76)',
    'surface-1':
      'color-mix(in srgb, var(--color-surface-0) 59%, var(--color-surface-4))',
    'surface-2':
      'color-mix(in srgb, var(--color-surface-0) 30%, var(--color-surface-4))',
    'surface-3':
      'color-mix(in srgb, var(--color-surface-0) 5%, var(--color-surface-4))',
    'surface-4': 'oklch(98.12% 0.0054 70)',
    'content-0': 'oklch(43.79% 0.0333 55)',
    'content-1':
      'color-mix(in srgb, var(--color-content-0) 75%, var(--color-content-4))',
    'content-2':
      'color-mix(in srgb, var(--color-content-0) 50%, var(--color-content-4))',
    'content-3':
      'color-mix(in srgb, var(--color-content-0) 25%, var(--color-content-4))',
    'content-4': 'oklch(59.5% 0.0397 59)',
    edge: 'oklch(66.5% 0.0703 57.89 / 0.21)',
    'edge-muted': 'color-mix(in oklch, var(--color-edge) 70%, transparent)',
    accent: 'oklch(0.62 0.16 55deg)',
    red: 'oklch(54.51% 0.2036 28.71)',
    orange: 'oklch(62.17% 0.1708 45.9)',
    amber: 'oklch(72.52% 0.1425 77.61)',
    yellow: 'oklch(72.52% 0.1425 77.61)',
    lime: 'oklch(65.64% 0.1354 109.1)',
    green: 'oklch(65.64% 0.1354 109.1)',
    teal: 'oklch(64.5% 0.0939 145.3)',
    cyan: 'oklch(64.5% 0.0939 145.3)',
    blue: 'oklch(47.05% 0.0819 215.7)',
    violet: 'oklch(59.73% 0.1105 352.2)',
    purple: 'oklch(59.73% 0.1105 352.2)',
    pink: 'oklch(63.59% 0.1549 341.8)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-blue)',
    'link-hover': 'oklch(60.37% 0.0934 215.7)',
    'link-visited': 'oklch(45.02% 0.1102 215.7)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-3) 98%, var(--color-content-0))',
  },
} satisfies ThemeV3;
